import { useAuthState } from '../../redux/reducers/authReducer';

export type AuthenticatedProps = {
    children?: React.ReactNode;
};
export const Authenticated = (props: AuthenticatedProps) => {
    const { children } = props;

    //Hooks
    const authState = useAuthState();
    
    return <>{authState.userId && <>{children}</>}</>;
};

export type UnauthenticatedProps = {
    children?: React.ReactNode;
};
export const Unauthenticated = (props: UnauthenticatedProps) => {
    const { children } = props;

    //Hooks
    const authState = useAuthState();

    return <>{!authState.userId && <>{children}</>}</>;
};
